export enum KeywordSortByTypeGq {
  VOLUME = 'VOLUME',
  TRANSLATED_VOLUME = 'TRANSLATED_VOLUME',
  ORIGINAL_VOLUME = 'ORIGINAL_VOLUME',
  KEYWORD = 'KEYWORD',
  TAG_GROUP = 'TAG_GROUP',
  CPC = 'CPC',
  COMPETITION = 'COMPETITION',
  DOMAIN_RANK = 'DOMAIN_RANK',
  DOMAIN_TRAFFIC = 'DOMAIN_TRAFFIC',
  PROGRESS_DOMAIN_RANK_CHANGE = 'PROGRESS_DOMAIN_RANK_CHANGE',
  PROGRESS_DOMAIN_TRAFFIC_CHANGE = 'PROGRESS_DOMAIN_TRAFFIC_CHANGE',
  TRANSLATED_WORD = 'TRANSLATED_WORD',
  ENGLISH = 'ENGLISH',
  INDIRECT_SEED = 'INDIRECT_SEED',
  ARCHIVE_TIME = 'ARCHIVE_TIME',
  PEAK_QUARTER = 'PEAK_QUARTER',
  PEAK_MONTH = 'PEAK_MONTH',
  TREND = 'TREND',
  TAG_COUNT = 'TAG_COUNT',
}
